// *******************************************************************************
// File upload
// *******************************************************************************
// Ref - https://jsfiddle.net/alexjamesbrown/2nzL9f7g/

const filesToUpload = {};
const fileUploadInput = document.querySelectorAll('.upload-box__input');

fileUploadInput.forEach((inputEle) => {
  const parentElem = inputEle.closest('.upload-box');
  const uploadBoxId = parentElem.getAttribute('data-upload-id');
  filesToUpload[uploadBoxId] = [];
  let nextFileID = 1;
  // const fileRemoved = new Event('fileRemoved');

  const fileUploader = (evt, files) => {
    const filesArray = filesToUpload[uploadBoxId];
    const selectedList = parentElem.querySelector('.upload-box__list-text-wrapper');
    const selectedListParent = parentElem.querySelector('.upload-box__list');

    Array.from(files).forEach((file) => {
      filesArray.push({ id: nextFileID++, file, inputName: inputEle.name });
    });

    const fileName = filesArray
      .map(
        (file) =>
          `<li><div class="upload-box__list-left"><div class="upload-box__list-icon : d-flex-cc"><i class="icon : icon-check"></i></div><div class='upload-box__list-text'>${file.file.name}</div></div><button id=${file.id} type='button' class='upload-box__list-remove : delete-button : delete-button--small-transparent' aria-label="Remove File"> <i class="icon : icon-trash"></i> </button></li>`,
      )
      .join('');

    selectedListParent.classList.remove('hide');
    selectedList.innerHTML = `<ul>${fileName}</ul>`;
  };

  inputEle.addEventListener('change', (evt) => {
    fileUploader(evt, evt.target.files);
  });

  // File drop
  const holder = parentElem.querySelector('.upload-box__inner');
  if (holder) {
    let dragCounter = 0;

    holder.addEventListener('dragenter', (e) => {
      e.preventDefault();
      dragCounter++;
      parentElem.classList.add('is-hovered');
    });

    holder.addEventListener('dragover', (e) => {
      e.preventDefault();
    });

    holder.addEventListener('dragleave', () => {
      dragCounter--;
      if (dragCounter === 0) {
        parentElem.classList.remove('is-hovered');
      }
    });

    holder.addEventListener('drop', (e) => {
      e.preventDefault();
      dragCounter = 0;
      parentElem.classList.remove('is-hovered');

      inputEle.files = e.dataTransfer.files;
      fileUploader(e, e.dataTransfer.files);
    });
  }

  // *******************************************************************************
  // Remove uploaded files
  // *******************************************************************************

  attachEvent('.upload-box__list-remove', 'click', (el) => {
    const removeParentElem = el.target.closest('li');
    const uploadBoxId = parentElem.getAttribute('data-upload-id');
    const filesArray = filesToUpload[uploadBoxId];

    if (filesArray) {
      Array.from(filesArray).forEach((file, i) => {
        if (file && file.id === Number(el.target.id)) {
          filesArray.splice(i, 1);
        }
      });
    }

    removeParentElem.remove();
    inputEle.value = '';
  });
});
